import { Field, Int, ObjectType } from '@nestjs/graphql'
import { CancellationDto } from './cancellation.dto'

@ObjectType()
export class CancellationPageDto {
  @Field(t => [CancellationDto])
  items!: CancellationDto[]

  @Field(t => Int)
  totalRows!: number
}
